module.exports = __webpack_public_path__ + "media/the-curse-of-the-sad-mummy-amumu-music-video-league-of-legends.a5b3c6ef.mp3";